import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { routeByName } from '@commerce/core'
import { CatalogPage } from './pages/CatalogPage'
import { ProductDetailPage } from './pages/ProductDetailPage'
import { CartPage } from './pages/CartPage'
import { LoginPage } from './pages/LoginPage'
import { DistributorPage } from './pages/DistributorPage'
import { DeliveryPage } from './pages/DeliveryPage'
import { PaymentPage } from './pages/PaymentPage'
import { ProcessingPage } from './pages/ProcessingPage'
import { ConfirmedPage } from './pages/ConfirmedPage'
import { OrdersPage } from './pages/OrdersPage'
import { OrderDetailPage } from './pages/OrderDetailPage'
import { AccountPage } from './pages/AccountPage'

// Out of scope for this slice; each is a deliberate omission, not a stub.
// TODO(post-hackathon): filters, categories nav, search, recommendations,
// prefill cart.

/**
 * The route table, with the router left out so a test can mount it inside a
 * `MemoryRouter`. The plan folds this into `App`; splitting it is what makes
 * "the paths in `ROUTE_MAP` reach the right page" an assertion rather than a
 * claim.
 *
 * Every `element` is a static import. That is the bundle win: Rollup can see
 * and tree-shake each page, where cinnamon's `module[runtimeString]` forces the
 * whole component library into every build.
 *
 * The order matters for `/orders` and `/orders/:orderId`: React Router ranks
 * static segments above dynamic ones, so listing them in either order works —
 * but keeping the list in `ROUTE_MAP`'s order is what makes the two readable
 * side by side.
 */
export const AppRoutes = () => (
  <Routes>
    {/* The bare storefront URL. Same screen as `login`, but with no session in
        the URL yet — entering is what mints it. */}
    <Route path={routeByName('home').path} element={<LoginPage />} />
    <Route path={routeByName('login').path} element={<LoginPage />} />
    <Route path={routeByName('distributor').path} element={<DistributorPage />} />
    <Route path={routeByName('catalog').path} element={<CatalogPage />} />
    <Route path={routeByName('productDetail').path} element={<ProductDetailPage />} />
    <Route path={routeByName('cart').path} element={<CartPage />} />
    <Route path={routeByName('delivery').path} element={<DeliveryPage />} />
    <Route path={routeByName('payment').path} element={<PaymentPage />} />
    <Route path={routeByName('processing').path} element={<ProcessingPage />} />
    <Route path={routeByName('confirmed').path} element={<ConfirmedPage />} />
    <Route path={routeByName('orders').path} element={<OrdersPage />} />
    <Route path={routeByName('orderDetail').path} element={<OrderDetailPage />} />
    <Route path={routeByName('account').path} element={<AccountPage />} />
    <Route path="*" element={<p>Not found</p>} />
  </Routes>
)

export const App = () => (
  <BrowserRouter>
    <AppRoutes />
  </BrowserRouter>
)
